import { useQuery } from '@hooks/reactQuery';

import { getMoBranches } from '@api/configurationComparison';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IMoBranchesDTO, IPresetParams, ISubmittedPathParamsProps } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { MO_PRESET_BRANCHES } from '@constants/queryKeys';

interface IUseQueryMoBranchesProps extends TDefaultDTO, ISubmittedPathParamsProps, Partial<IPresetParams> {
	isDifferenceOnly: boolean;
	progressId?: string;
	setRefetchIntervalProgress: (v: false) => void;
}

export const useQueryMoPresetBranches = (params: IUseQueryMoBranchesProps) => {
	const {
		isDifferenceOnly,
		isPresetTableView,
		page,
		pageSize,
		progressId,
		savedPreset,
		searchValue,
		setRefetchIntervalProgress,
		sortDirection,
		sortFieldName,
		submittedPath,
	} = params || {};

	const {
		data: presetBranches,
		isLoading: isLoadingPresetBranches,
		isFetching: isFetchingPresetBranches,
	} = useQuery({
		queryKey: [
			MO_PRESET_BRANCHES,
			pageSize,
			page,
			sortDirection,
			sortFieldName,
			searchValue,
			savedPreset,
			isPresetTableView,
		],
		queryFn: () => getMoBranches({
			...savedPreset,
			progressId,
			pageSize,
			page,
			sortDirection,
			sortFieldName,
			searchValue,
			categoryPaths: submittedPath,
			onlyChanged: isDifferenceOnly,
		} as IMoBranchesDTO),
		enabled: [
			!!progressId,
			!!savedPreset,
			isPresetTableView,
		],
		refetchOnWindowFocus: false,
		refetchOnmount: false,
		onError: (err: IResponseError) => {
			setRefetchIntervalProgress(false);
			handleErrorFromMessage(err);
		},
	});

	return { presetBranches, isLoadingPresetBranches, isFetchingPresetBranches };
};
